import styled from 'styled-components';
import { UiColors } from 'assets/styles/old/global';

/**
 * Borderless cluster: first / previous arrows, "Page 3 of 444", next / last arrows — all forest, at
 * the 14px of the counts it sits beside in the toolbar (see the media tabs' Styled.Count), so the
 * whole right-hand side of that row reads as one line of text rather than a field bolted next to a
 * label.
 *
 * No frame and no dividers, so the arrow pairs have to carry the grouping themselves: the cells are
 * only a couple of pixels wider than the glyphs, which puts each double-chevron right up against
 * its single one and leaves the label's padding as the only real gap in the control.
 */
export const Wrapper = styled.nav`
  display: inline-flex;
  align-items: center;
  height: 24px;
  color: ${UiColors.forestColor};
  white-space: nowrap;
`;

/* "Page 3 of 444" — the page number carries the weight, "Page"/"of" stay lighter at the same size.
   Tabular figures so the arrows beside it don't shift as the numbers grow. */
export const Label = styled.span`
  display: inline-flex;
  align-items: center;
  /* The only gap in the cluster now that the dividers are gone. */
  padding: 0 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${UiColors.forestColor};
  font-variant-numeric: tabular-nums;
  /* It can sit inside an uppercased/tracked header cell — read as normal case regardless. */
  text-transform: none;
  letter-spacing: normal;

  > strong {
    margin: 0 3px;
    font-weight: 700;
    color: ${UiColors.forestColor};
  }
`;

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Barely wider than the 13px glyph: keeps « hard against ‹ (and › against ») on both sides. */
  width: 16px;
  height: 20px;
  padding: 0;
  border: none;
  /* No frame to clip the hover fill any more, so the cell rounds itself. */
  border-radius: 4px;
  background: transparent;
  color: ${UiColors.forestColor};
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;

  svg {
    width: 13px;
    height: 13px;
  }

  &:hover:not(:disabled) {
    background: ${UiColors.cloudColor};
  }

  &:active:not(:disabled) {
    background: ${UiColors.forestColor};
    color: ${UiColors.peachColor};
  }

  /* Forest at a third of its strength — still the same colour, just clearly out of reach. */
  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
`;
